import { JetView, plugins } from 'webix-jet'; // Import necessary modules from webix-jet
import MenuView from 'jet-views/menu'; // Import MenuView component
import ToolView from 'jet-views/toolbar'; // Import ToolView component
import { devConfig } from 'config/config'; // Import development configuration

/**
 * Represents the ReportsCustomerView class.
 * @extends JetView
 */
export default class ReportsCustomerView extends JetView {
    /**
     * Configures the layout of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        return {
            type: 'wide', // Layout type
            cols: [
                {
                    localId: 'inner:layout', // Local ID for the layout
                    type: 'wide', // Layout type
                    rows: [
                        {
                            view: 'tabbar', // Tab bar component
                            localId: 'tabbar', // Local ID for the tab bar
                            height: 43, // Height of the tab bar
                            tabMinWidth: 190, // Minimum width of tabs
                            tabMoreWidth: 80, // Width of 'more' tab
                            /**
                             * Template for the 'more' tab.
                             * @returns {string} The HTML string for the 'more' tab.
                             */
                            moreTemplate: function () {
                                return (
                                    "<div style='font-weight: bold;border-left: 1px solid #ebedf0;height: 30px;line-height: 2;padding-left: 5px;color: #263043;'>" +
                                    _('Ver más') + // Localized text for 'more'
                                    '</div>'
                                );
                            },
                            options: [
                                // Options for the tab bar
                                {
                                    id: 'betShopManagement.depositReportBetShop', // Unique ID for the option
                                    value: _('Reporte de Depósitos'), // Localized value
                                    hidden: !devConfig.getPermAction(
                                        // Visibility based on permissions
                                        'betShopManagement.depositReportBetShop',
                                        'Menu',
                                    ),
                                    css: 'prm-betShopManagement.depositReportBetShop', // CSS class for styling
                                },
                                {
                                    id: 'betShopManagement.financial.withdrawalRequestsBetShop',
                                    value: _('Reporte de Retiros'),
                                    hidden: !devConfig.getPermAction(
                                        'betShopManagement.financial.withdrawalRequestsBetShop',
                                        'Menu',
                                    ),
                                    css: 'prm-betShopManagement.financial.withdrawalRequestsBetShop',
                                },
                                {
                                    id: 'betShopManagement.reports.betsReportBetShop',
                                    value: _('Reporte de Apuestas'),
                                    hidden: !devConfig.getPermAction(
                                        'betShopManagement.reports.betsReportBetShop',
                                        'Menu',
                                    ),
                                    css: 'prm-betShopManagement.reports.betsReportBetShop',
                                },
                                {
                                    id: 'betShopManagement.flujoCajaBetShop',
                                    value: _('Reporte Flujo de Caja'),
                                    hidden: !devConfig.getPermAction('betShopManagement.flujoCajaBetShop', 'Menu'),
                                    css: 'prm-betShopManagement.flujoCajaBetShop',
                                },
                                {
                                    id: 'betShopManagement.reports.historyMovement',
                                    value: _('Historial de movimientos'),
                                    hidden: !devConfig.getPermAction(
                                        'betShopManagement.reports.historyMovement',
                                        'Menu',
                                    ),
                                    css: 'prm-betShopManagement.reports.historyMovement',
                                },
                                {
                                    id: 'betShopManagement.reports.userAffiliatesBetShop',
                                    value: _('Usuarios Afiliados'),
                                    hidden: !devConfig.getPermAction(
                                        'betShopManagement.reports.userAffiliatesBetShop',
                                        'Menu',
                                    ),
                                    css: 'prm-betShopManagement.reports.userAffiliatesBetShop',
                                },
                            ],
                        },
                        { $subview: true }, // Placeholder for subview
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     */
    init() {
        webix.ready(function () {
            // Wait for Webix to be ready
            webix.attachEvent('onRotate', function (orientation) {
                // Event for screen rotation
                window.location.reload(); // Reload the page on rotation
            });
        });
        this.use(plugins.Menu, this.$$('tabbar')); // Use Menu plugin with the tab bar
        this.on(
            this.app,
            'person:select',
            (
                person, // Event listener for person selection
            ) => this.setParam('user', person.id, true), // Set user parameter
        );
    }
}

// FILE DOCUMENTED
